interface IBankDetails {
  placeHolder: string;
  content: string;
  description?: string;
  hasIcon: boolean;
}

interface IBankData {
  USD: IBankDetails[];
  USBurling: IBankDetails[];
  USSubsidiary: IBankDetails[];
  AUD: IBankDetails[];
  EUR: IBankDetails[];
  NZD: IBankDetails[];
  GBP: IBankDetails[];
}

const USBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "Caleb and Brown Pty Ltd‍",
    description: "Please use account name listed here, not ‘Caleb & Brown’",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "LI36 0881 1010 5373 K000 U",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary address",
    content: "Level 3, 2-6 Gwynne Street, Cremorne, Victoria, 3121, Australia",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Bank",
    content: "Bank Frick",
    description: "Landstrasse 14, 9496 Balzers, Liechtenstein",
    hasIcon: false,
  },
  {
    placeHolder: "Payment description code",
    content: "CustomerId",
    description:
      "Please do NOT include “Bitcoin”, “Crypto” or “BTC” in your payment description or your deposit will not be credited.",
    hasIcon: true,
  },
  {
    placeHolder: "SWIFT/BIC Code",
    content: "BFRILI22XXX",
    description: "",
    hasIcon: true,
  },
];

export const USBurlingBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "CALEB AND BROWN PTY LTD",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "130354",
    description: "Please note: this account type is a Checking Account.",
    hasIcon: true,
  },
  {
    placeHolder: "Bank",
    content: `Burling Bank`,
    description: "141 W. Jackson Blvd., Chicago, IL 60604",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary Address",
    content: "LEVEL 3, 2-6 GWYNNE STREET, CREMORNE, VIC 3121 AUSTRALIA",
    hasIcon: true,
  },
  {
    placeHolder: "ABA Routing Number",
    content: "071005254",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment Description:",
    content:
      "Please enter your Customer ID + your name or entity e.g. ‘CU123456 John Citizen’ or ‘CU123456 Example Investments LLC’",
    description: "",
    hasIcon: true,
  },
];

const AUBankDetails = [
  {
    placeHolder: "BSB",
    content: "806043",
    description: "If required - BSB / IRC (International Routing Code)",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "100258296",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Bank",
    content: `BNK Banking Corporation Limited trading as "Goldfields Money"`,
    description: "Lvl 14, 191 St Georges Terrace, Perth WA 6000",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account name",
    content: "Caleb and Brown Pty Ltd",
    description: "Please use account name listed here, not ‘Caleb & Brown’",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary Address",
    content: "Level 3, 2-6 Gwynne Street, Cremorne, 3121",
    hasIcon: true,
  },
  {
    placeHolder: "SWIFT code",
    content: "CUSCAU2SXXX",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment description code",
    content: "CustomerId",
    description:
      "Please do NOT include “Bitcoin”, “Crypto” or “BTC” in your payment description or your deposit will not be credited.",
    hasIcon: true,
  },
];

const EURBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "Caleb and Brown Pty Ltd",
    description: "Please use account name listed here, not ‘Caleb & Brown’",
    hasIcon: true,
  },
  {
    placeHolder: "IBAN/Beneficiary account number",
    content: "DK51 8900 0051 6977 02",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary address",
    content: "Level 5, 2-6 Gwynne Street, Cremorne, Victoria, 3121, Australia",
    description: "",
    hasIcon: false,
  },

  {
    placeHolder: "Bank",
    content: "Banking Circle",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Bank address",
    content: "Amerika Plads 38, Kobenhavn Ø, 2100 Denmark",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "SWIFT code",
    content: "SXPYDKKKXXX",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment description code",
    content: "CustomerId",
    description:
      "Please do NOT include “Bitcoin”, “Crypto” or “BTC” in your payment description or your deposit will not be credited.",
    hasIcon: true,
  },
];

const NZDBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "Caleb and Brown Pty Ltd‍",
    description: "Please use account name listed here, not ‘Caleb & Brown’",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "LI31 0881 1010 5373 K000 N",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary address",
    content: "LEVEL 3 2-6 GWYNNE ST, CREMORNE, VIC, 3121, Australia",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Bank",
    content: "Bank Frick",
    description: "Landstrasse 14, 9496 Balzers, Liechtenstein",
    hasIcon: false,
  },
  {
    placeHolder: "SWIFT code",
    content: "BFRILI22XXX",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment description code",
    content: "CustomerId",
    description:
      "Please do NOT include “Bitcoin”, “Crypto” or “BTC” in your payment description or your deposit will not be credited.",
    hasIcon: true,
  },
];

const GBPBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "Caleb and Brown Pty Ltd",
    description: "Please use account name listed here, not ‘Caleb & Brown’",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "00003195",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Sort code",
    content: "040541",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "IBAN",
    content: "GB74 BCPY 040541 00003195",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary address",
    content: "Level 4, 33 Cremorne Street, VIC 3121, Australia",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Currency",
    content: "GBP",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Bank",
    content: "BCB Payments Ltd",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "Bank address",
    content: "Merchant Square London, W2 1AS United Kingdom",
    description: "",
    hasIcon: false,
  },
  {
    placeHolder: "SWIFT code",
    content: "BCPYGB22",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment description code",
    content:
      "Please enter your Customer ID + your name e.g. ‘CU123456 John Citizen’ or ‘CU123456 Example Investments LLC’",
    description:
      "Please do NOT include “Bitcoin”, “Crypto” or “BTC” in your payment description or your deposit will not be credited.",
    hasIcon: true,
  },
];

export const USSubsidiaryBankDetails = [
  {
    placeHolder: "Beneficiary account name",
    content: "CALEB AND BROWN LTD",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary account number",
    content: "4000015190",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Beneficiary Address",
    content: "LEVEL 3, 2-6 GWYNNE STREET, CREMORNE, VIC 3121 AUSTRALIA",
    hasIcon: true,
  },
  {
    placeHolder: "Currency",
    content: "USD",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Bank",
    content: `Old Glory Bank`,
    description: "3401 NW 63rd Street Oklahoma City, OK 73116",
    hasIcon: true,
  },
  {
    placeHolder: "ABA Routing Number",
    content: "103113441",
    description: "",
    hasIcon: true,
  },
  {
    placeHolder: "Payment Description:",
    content:
      "Please enter your Customer ID + your name or entity e.g. ‘CU123456 John Citizen’ or ‘CU123456 Example Investments LLC’",
    description: "",
    hasIcon: true,
  },
];

export const BANK_DATA: IBankData = {
  USD: USBankDetails,
  USBurling: USBurlingBankDetails,
  USSubsidiary: USSubsidiaryBankDetails,
  AUD: AUBankDetails,
  EUR: EURBankDetails,
  NZD: NZDBankDetails,
  GBP: GBPBankDetails,
};
